const items = document.querySelectorAll(".accordion button");

function toggleAccordion() {
  const itemToggle = this.getAttribute('aria-expanded');
  for (i = 0; i < items.length; i++) {
    items[i].setAttribute('aria-expanded', 'false');
  }
  if (itemToggle == 'false') {
    this.setAttribute('aria-expanded', 'true');
  }
}
items.forEach(item => item.addEventListener('click', toggleAccordion));


const buyOnlineContainer = document.querySelector(".buy-online-container");
const buyOnlineBtn = document.querySelector("#buy-online-button");

if(buyOnlineBtn) {
  buyOnlineBtn.addEventListener('click', function(e) {
    e.preventDefault();
    console.log(buyOnlineContainer.getAttribute('aria-expanded'))
    if(buyOnlineContainer.getAttribute('aria-expanded') == "false") {
      buyOnlineContainer.setAttribute('aria-expanded', 'true');
    } else {
      buyOnlineContainer.setAttribute('aria-expanded', 'false');
    }
  }); 
}
window.forceCompareReload = ()=>{
  window.spCompareIsLoaded = null
  window.spCompareIsScriptTagVersion = null
  document.querySelectorAll('.SPCMP_chk_lbl').forEach((node)=>{node.remove()})
  var node = document.querySelector('#compare-js').cloneNode(true)
  node.removeAttribute('defer')
  document.querySelector('#compare-js').remove()
  document.body.appendChild(node)
}
window.addEventListener('globoFilterRenderCompleted',(e)=>{
  window.forceCompareReload()
})